import { DestroyRef, Injectable, effect, inject, signal } from '@angular/core';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import dayjs from "dayjs";

@Injectable({ providedIn: 'root' })

export class SendCurrentRouteService {
    private _route = inject(CustomRouteService);

    getRoute(){
        const route = this._route.customRouteData();
        if (route?.dailyRoutes?.length === 0)
            return {
                'is_successful': false,
                'reason': 'No se ha generado la ruta'
            }
            
        const mappedRoute = route?.dailyRoutes?.map(dailyRoute => {
            const date = dayjs(dailyRoute.date)?.format('YYYY-MM-DD');
            const points = dailyRoute.points?.map(point => ({
                id: point.id,
                title: point?.title,
                type: point?.type,
                duration: point?.duration,
                startDate: dayjs(point?.startDate)?.format('YYYY-MM-DDTHH:mm:ss'),
                endDate: dayjs(point?.endDate)?.format('YYYY-MM-DDTHH:mm:ss'),
            }))
            return {
                date,
                startPoint: dailyRoute.startPoint?.address,
                endPoint: dailyRoute.endPoint ? dailyRoute.startPoint?.address : null,
                points
            }
        })
        console.log("Route:", mappedRoute)

        return {
            'is_successful': true,
            'content': mappedRoute
        }
    }

}